import axios from 'axios'

let cache = {}
let loading = {}

const getLoadPath = function (iconName) {
  return import('@common/assets/icons/' + iconName + '.svg'
    /* webpackChunkName: "icons" */
    /* webpackInclude: /\.svg/ */
    /* webpackMode: "lazy-once" */)
    .then(icon => {
      return icon.default
    })
}

const loadFile = function (iconPath) {
  axios.get(iconPath)
    .then(response => {
      cache[iconPath] = response.data
      loading[iconPath].forEach(request => request.resolve(response.data))
    })
    .catch(error => {
      loading[iconPath].forEach(request => request.reject(error))
    })
    .finally(() => {
      delete loading[iconPath]
    })
}

export function loadIcon (name) {
  return new Promise((resolve, reject) => {
    getLoadPath(name)
      .then(iconPath => {
        if (cache[iconPath]) {
          resolve(cache[iconPath])

          return
        }

        let load = false

        if (!loading[iconPath]) {
          load = true
          loading[iconPath] = []
        }

        loading[iconPath].push({
          resolve,
          reject
        })

        if (load) {
          loadFile(iconPath)
        }
      })
  })
}
